import { Box, Divider, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";

interface Props {
  title: string;
  onClose: () => void;
}

const SwipeableBottomDrawerHeader = ({ title, onClose }: Props) => {
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", px: 2, pt: 2, pb: 1 }}>
        {/* Invisible twin of the close button so its width mirrors exactly, keeping the title centered */}
        <CloseIconButton sx={{ visibility: "hidden" }} aria-hidden tabIndex={-1} />
        <Typography variant="subtitle1" noWrap sx={{ flexGrow: 1, textAlign: "center" }}>
          {title}
        </Typography>
        <CloseIconButton onClick={onClose} />
      </Box>
      <Divider />
    </>
  );
};

export default SwipeableBottomDrawerHeader;
